import {
  SET_PASSWORD_SUCCEEDED,
  SET_PASSWORD_FAILURE,
  INVALID_CODE,
  VALID_CODE,
  LOADING_STATE,
  GET_EMAILS_VALUES_SUCCEEDED,
  REVERT_TO_OLD_EMAIL_SUCCEEDED,
  REVERT_TO_OLD_EMAIL_ERROR,
  PASSWORD_RESET_CONFIRMATION_SENT,
  PASSWORD_RESET_CONFIRMATION_FAILED,
  EMAIL_VERIFICATION_SUCCEEDED,
  EMAIL_VERIFICATION_ERROR,
  SIGNIN_WITH_EMAIL_LINK_SUCCEEDED,
  SIGNIN_WITH_EMAIL_LINK_ERROR
} from './types';

const INITIAL_STATE = {
  passwordUpdated: '',
  fromEmail: '',
  email: '',
  loading: false,
  emailSent: false,
  isEmailVerified: false,
  emailVerificationError: '',
  signInLinkSuccess: false,
  signInLinkError: ''
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === SET_PASSWORD_SUCCEEDED) {
    return { ...state, passwordUpdated: true };
  } else if (action.type === SET_PASSWORD_FAILURE) {
    return { ...state, passwordUpdated: false };
  } else if (action.type === INVALID_CODE) {
    return { ...state, invalidCode: true, loading: false };
  } else if (action.type === VALID_CODE) {
    return { ...state, invalidCode: false, loading: false };
  } else if (action.type === LOADING_STATE) {
    return { ...state, loading: true };
  } else if (action.type ===  GET_EMAILS_VALUES_SUCCEEDED) {
    return { ...state, ...action.payload, emailSent: false };
  } else if (action.type === REVERT_TO_OLD_EMAIL_SUCCEEDED) {
    return { ...state, invalidRevertEmailCode: false, loading: false, emailSent: false };
  } else if (action.type === REVERT_TO_OLD_EMAIL_ERROR) {
    return {
      ...state,
      invalidRevertEmailCode: true,
      loading: false,
      invalidRevertEmailCodeError: action.payload,
      emailSent: false
    }
  } else if (action.type === PASSWORD_RESET_CONFIRMATION_SENT) {
    return { ...state, emailSent: true, loading: false };
  } else if (action.type === PASSWORD_RESET_CONFIRMATION_FAILED) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === EMAIL_VERIFICATION_SUCCEEDED) {
    return { ...state, isEmailVerified: true, loading: false };
  } else if (action.type === EMAIL_VERIFICATION_ERROR) {
    return { ...state, emailVerificationError: action.payload, isEmailVerified: false, loading: false };
  } else if (action.type === SIGNIN_WITH_EMAIL_LINK_SUCCEEDED) {
    return { ...state, signInLinkSuccess: true, loading: false };
  } else if (action.type === SIGNIN_WITH_EMAIL_LINK_ERROR) {
    return { ...state, signInLinkSuccess: false, signInLinkError: action.payload, loading: false };
  } else {
    return state;
  }
}
